import React from 'react';
import PropTypes from 'prop-types';
import './AmexImage.scss';

const AmexImage = ({
  urlPrefix,
  images,
  imageAlt,
  mediaBreakpoint = 768,
  matchMedia,
}) => {
  const {
    desktop: desktopImg = '',
    mobile: mobileImg = '',
  } = images || {};
  const getImageUrl = (name) => `${urlPrefix}${name}`;
  const buildSrcSet = (img) => `${img} 2x`;

  const hasRequiredImages = !!(desktopImg && mobileImg);
  const desktopImage = getImageUrl(desktopImg);
  const mobileImage = getImageUrl(mobileImg);
  const fallbackImage = matchMedia.md ? desktopImage : mobileImage;
  const updatedImageAlt = hasRequiredImages ? imageAlt : 'missing banner image';

  return (
    <picture className="AmexImage__image">
      <source
        media={`(min-width: ${mediaBreakpoint}px)`}
        srcSet={buildSrcSet(desktopImage)}
      />
      <source srcSet={buildSrcSet(mobileImage)} />
      <img
        className="AmexImage__image-default"
        src={fallbackImage}
        alt={updatedImageAlt}
        decoding="async"
        fetchpriority="high"
      />
    </picture>
  );
};

AmexImage.propTypes = {
  images: PropTypes.shape({
    desktop: PropTypes.string.isRequired,
    mobile: PropTypes.string.isRequired,
  }).isRequired,
  imageAlt: PropTypes.string,
  mediaBreakpoint: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  urlPrefix: PropTypes.string.isRequired,
};

AmexImage.defaultProps = {
  imageAlt: '',
  mediaBreakpoint: 768,
};

export default AmexImage;
